export default {
  getSearchTextKeyword: (keywords: string, exactMatch: boolean) => {
    return exactMatch && keywords ? `"${keywords}"` : keywords;
  },
};
